export const version = "6.5.0";
export const major = Number("6");
export const minor = Number("5");
export const patch = Number("0");
export const prerelease = undefined;
export default version;